
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.036 4.427a6.7 6.7 0 00-1.196-.363V3.25c0-.69-.569-1.25-1.27-1.25-.7 0-1.268.56-1.268 1.25v.814c-2.916.596-5.077 3.026-5.077 6.061 0 3.748-1.262 5.054-2.052 5.87l-.15.157a1.21 1.21 0 00-.341.848 1.26 1.26 0 001.273 1.25h15.23c.76 0 1.27-.61 1.274-1.25a1.21 1.21 0 00-.341-.848l-.15-.157c-.59-.609-1.441-1.49-1.836-3.456a5.73 5.73 0 01-4.096-8.112zM14.109 19.5c0 1.38-1.137 2.5-2.538 2.5-1.402 0-2.539-1.12-2.539-2.5h5.077z","fill":"#fff"}}),_c('path',{attrs:{"d":"M23.027 6.91a3.827 3.827 0 11-7.654 0 3.827 3.827 0 017.654 0z","fill":"#FF4954","color":"#ff4954"}})])
          )
        }
      }
    